// const DISCOUNT_CODE = 'CROOKED'
// const CART_LIMIT = 24
// const PRODUCT_VARIANT_ID = 44060459073788
// const PRODUCT_ID = 7969261977852
function _callHandleDiscountApply() {
  if (PRODUCT_UPSELL_INFO) {
    PRODUCT_UPSELL_INFO.forEach((product_upsell) => {
      handleDiscountApply(
        product_upsell.discountCode,
        product_upsell.cartLimit,
        product_upsell.productVariantId
      );
    });
  }
}
function handleDiscountApply(DISCOUNT_CODE, CART_LIMIT, PRODUCT_VARIANT_ID) {
  //rebuy-cart__flyout-discount-form
  document
    .querySelector(".rebuy-cart__flyout-discount-container")
    .addEventListener("submit", async () => {
      console.log("SUBMIT"); // samo jednom se pokrece a trebalo bi vise puta??
      const discountCode = document.querySelector(
        "#rebuy-discount-input"
      ).value;
      if (!discountCode.length) {
        return;
      }

      // get number from string eg. $30.00
      const currentCartValue = parseInt(
        document
          .querySelector(".rebuy-cart__flyout-subtotal-amount")
          .innerText.split(".")[0]
          .replace(/[^a-zA-Z0-9]/g, "")
      );
      if (
        currentCartValue < CART_LIMIT ||
        discountCode.toUpperCase() !== DISCOUNT_CODE
      ) {
        return;
      }

      // Rebuy is the class available on window -- will be working only on storefront though
      const hasItemAlready = Rebuy.Cart.cart.items.some(
        (item) => item.id === PRODUCT_VARIANT_ID
      );
      console.log(hasItemAlready);
      if (hasItemAlready) {
        return;
      }

      // add product to the cart
      const addData = {
        quantity: 1,
        id: PRODUCT_VARIANT_ID,
      };

      const response = await fetch("/cart/add.js", {
        body: JSON.stringify(addData),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "xmlhttprequest",
        },
        method: "POST",
      });
    });
}

const existCondition = setInterval(function () {
  if ($(".rebuy-cart__flyout-discount-form").length) {
    console.log("Exists!");
    clearInterval(existCondition);
    _callHandleDiscountApply();
  }
}, 100); // check every 100ms
